module.exports = __webpack_public_path__ + "img/Avatar-68.4c686426.svg";